import { Button, Grid, SvgIcon, Typography, useTheme } from "@material-ui/core"
import { Report } from "@material-ui/icons"
import React, { Fragment } from "react"
import { useIntl } from "react-intl"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router"
import { hideModal } from '../../../redux/actions'
import { isMobile } from "../../../utilties/mobileDetector"


const RedirectErrorDialog = ({
    buttonUrl,
    authErrorCode,
    ua
}) => {
    const history = useHistory()
    const intl = useIntl()
    const dispatch = useDispatch()

    const authErrorButtonVisibility = {
        "51": false,
        "52": true,
        "53": true
    }

    const onButtonClick = () => {
        if (!buttonUrl) {
            return
        }

        history.push(buttonUrl)
        dispatch(hideModal())
    }

    const getTitle = () => {
        return intl.formatMessage({ id: `app.redirectErrorModal.${authErrorCode}.errorTitle` })
    }

    const getMessage = () => {
        return intl.formatMessage({ id: `app.redirectErrorModal.${authErrorCode}.errorMessage` })
    }

    const getButtonTitle = () => {
        return intl.formatMessage({ id: `app.redirectErrorModal.${authErrorCode}.buttonTitle` })
    }

    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            style={{
                width: isMobile ? '90hw' : '800px',
                padding: isMobile ? "60px 20px 60px 20px" : "20px 60px 60px 60px"
            }}
        >
            <Grid
                item
            >
                <Grid
                    container
                    direction={!isMobile ? "column-reverse" : "column"}
                    alignItems="center"
                >
                    <div>
                        <Grid
                            item
                        >
                            <Typography
                                variant="h3"
                                align="center"
                                style={{
                                    fontWeight: "500"
                                }}
                            >
                                { getTitle() }
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            style={{
                                paddingTop: isMobile ? "20px" : "5px"
                            }}
                        >
                            <Typography
                                variant={isMobile ? "subtitle1" : "h3"}
                                align="center"
                                style={{
                                    fontWeight: isMobile ? "300" : "500"
                                }}
                            >
                                { getMessage() }
                            </Typography>
                        </Grid>
                    </div>

                    <Grid
                        item
                        style={{
                            paddingTop: "30px",
                            paddingBottom: "20px"
                        }}
                    >
                        <div
                            style={{
                                width: "170px",
                                height: "170px",
                                backgroundColor: "#d9e6fc",
                                borderRadius: "85px",
                                position: "relative"
                            }}
                        >
                            <Report
                                style={{
                                    width: "130px",
                                    height: "130px",
                                    color: "white",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                }}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            {
                !!authErrorButtonVisibility[authErrorCode]
                && <Grid
                    item
                    style={{
                        paddingTop: "40px"
                    }}
                >
                    <Button
                        variant='contained'
                        color='primary'
                        style={{
                            width: '200px'
                        }}
                        onClick={onButtonClick}
                    >
                        { getButtonTitle() }
                    </Button>
                </Grid>
            }
        </Grid>
    )
}

export default RedirectErrorDialog